<template>
  <div class="min-h-screen flex flex-col items-center py-10 px-4">
    <!-- Header -->
    <div class="mobile-padding"></div>
    <div class="liquidGlassCard rounded-3xl p-6 w-full">
      <router-link class="absolute w-8 h-8 left-5 top-5" to="/">
        <ColorImg
          src="/images/icons/back.png"
          class="bg-current w-full h-full"
          alt=""
        />
      </router-link>
      <button
        class="absolute w-8 h-8 right-5 top-5"
        @click="Events.dispatch(EVENTS.LOGOUT_REQUESTED)"
      >
        <ColorImg
          src="/images/icons/logout.png"
          class="bg-primary w-full h-full"
          alt=""
        />
      </button>
      <!-- {{ Storage.get('userData') }} -->

      <div class="mt-8 flex items-center gap-4">
        <ActionTrigger
          dataKey="user"
          method="post"
          @success="onProfileUpdated"
          v-slot="{ trigger: updateProfile }"
        >
          <div class="relative group cursor-pointer" @click="triggerFileInput">
            <ImgComponent
              avatar
              :key="profilePicKey"
              :src="
                Storage.get('userData')?.profilePicture ||
                '/images/sample/avatar.jpg'
              "
              alt="Rider Avatar"
              class="w-32 h-32 rounded-full object-cover shadow border-4 border-white"
            />
            <div
              class="absolute inset-0 bg-black/30 rounded-full flex items-center justify-center opacity-0 group-active:opacity-100 transition-opacity"
            >
              <ColorImg
                src="/images/icons/camera.png"
                class="w-8 h-8 bg-white"
              />
            </div>
            <input
              type="file"
              ref="fileInput"
              class="hidden"
              accept="image/*"
              @change="handleFileUpload($event, updateProfile)"
            />
          </div>
        </ActionTrigger>

        <div class="">
          <div class="text-3xl font-bold title-color">
            {{ Storage.get('userData')?.firstName }}
            {{ Storage.get('userData')?.lastName }}
          </div>
          <div class="text-gray-500 mt-2">
            Rider ID : {{ Storage.get('userData')?.id }}
          </div>

          <div class="flex justify-start md:justify-start items-center mt-2">
            <div class="flex text-yellow-400">
              <template v-for="i in 5" :key="i">
                <svg
                  v-if="i <= Math.floor(rider.rating)"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  class="w-5 h-5"
                >
                  <path
                    d="M12 .587l3.668 7.431L24 9.748l-6 5.852 1.416 8.263L12 19.771l-7.416 4.092L6 15.6 0 9.748l8.332-1.73z"
                  />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  class="w-5 h-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M11.48 3.499l2.313 6.847h7.207l-5.834 4.24 2.314 6.846-5.834-4.241-5.834 4.241 2.314-6.846-5.834-4.24h7.207l2.311-6.847z"
                  />
                </svg>
              </template>
            </div>
            <span class="ml-2 text-gray-600 text-sm">{{ rider.rating }}/5</span>
          </div>
        </div>
      </div>
      <div class="py-5">
        <RiderAvailabilityUpdater />
      </div>
      <!-- <LevelBox class="mt-8 border rounded-2xl p-4" /> -->
    </div>

    <div class="liquidGlassCard rounded-3xl w-full mt-6" v-if="false">
      <div class="text-lg title-color p-8 pb-0">Badges</div>
      <div class="overflow-auto p-8 pt-0 mt-4">
        <div class="flex min-w-max gap-4">
          <div
            v-for="(badge, i) in badges?.length ? badges : [{}]"
            class=""
            :key="i"
          >
            <div
              class="flex flex-col items-center justify-center w-[24vw] text-center"
            >
              <div class="w-3/4">
                <div class="relative w-full py-[50%]">
                  <div class="absolute w-full h-full top-0 left-0">
                    <ImgComponent
                      v-if="badge.logo"
                      :src="badge.logo"
                      alt=""
                      class="rounded-full"
                    />
                    <div
                      v-else
                      class="rounded-3xl w-full h-full border-2 border-dashed border-primary-300"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="title-color text-sm mt-2">
                {{ !badges?.length ? 'Aucun badge' : badge.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Personal Info -->
    <div class="liquidGlassCard rounded-3xl p-6 w-full mt-6">
      <h2 class="text-lg font-semibold text-gray-700 mb-4">
        Informations personnelles
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p class="text-gray-500 text-sm">Téléphone</p>
          <p class="text-gray-800 font-medium">
            {{ Storage.get('userData')?.phoneNumber }}
          </p>
        </div>
        <div>
          <p class="text-gray-500 text-sm">Email</p>
          <p class="text-gray-800 font-medium">
            {{ Storage.get('userData')?.email }}
          </p>
        </div>
        <!-- <div>
          <p class="text-gray-500 text-sm">Adresse</p>
          <p class="text-gray-800 font-medium">{{ rider.address }}</p>
        </div> -->
        <!-- <div>
          <p class="text-gray-500 text-sm">Date d'inscription</p>
          <p class="text-gray-800 font-medium">
            {{ formatDate(Storage.get('userData')?.createdAt) }}
          </p>
        </div> -->
      </div>
    </div>

    <!-- Shop Link Section -->
    <div
      class="liquidGlassCard rounded-3xl p-6 w-full mt-6 flex items-center justify-between"
    >
      <div class="flex items-center gap-4">
        <div
          class="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center"
        >
          <ColorImg
            src="/images/icons/shopping-bag.svg"
            class="w-6 h-6 bg-primary"
          />
        </div>
        <div>
          <h2 class="text-lg font-semibold text-gray-700">Boutique Rapidoo</h2>
          <p class="text-sm text-gray-500">
            Équipez-vous aux couleurs de Rapidoo
          </p>
        </div>
      </div>
      <router-link to="/shop" class="buttonComponent small"
        >Découvrir</router-link
      >
    </div>

    <!-- Purchases History Section -->
    <div
      class="liquidGlassCard rounded-3xl p-6 w-full mt-6 flex items-center justify-between"
    >
      <div class="flex items-center gap-4">
        <div
          class="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center"
        >
          <ColorImg
            src="/images/icons/package-delivered.svg"
            class="w-6 h-6 bg-secondary"
          />
        </div>
        <div>
          <h2 class="text-lg font-semibold text-gray-700">Mes achats</h2>
          <p class="text-sm text-gray-500">Suivez vos commandes d'équipement</p>
        </div>
      </div>
      <router-link to="/mes-achats" class="buttonComponent small secondary"
        >Consulter</router-link
      >
    </div>

    <!-- Notifications Section -->
    <div
      class="liquidGlassCard rounded-3xl p-6 w-full mt-6 flex items-center justify-between"
    >
      <div class="flex items-center gap-4">
        <div
          class="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center"
        >
          <ColorImg
            src="/images/icons/notification.png"
            class="w-6 h-6 bg-orange-500"
          />
        </div>
        <div>
          <h2 class="text-lg font-semibold text-gray-700">Notifications</h2>
          <p class="text-sm text-gray-500">Consultez vos alertes et messages</p>
        </div>
      </div>
      <router-link to="/inbox" class="buttonComponent small">Voir</router-link>
    </div>

    <!-- Support Section -->
    <div
      class="liquidGlassCard rounded-3xl p-6 w-full mt-6 flex items-center justify-between"
    >
      <div class="flex items-center gap-4">
        <div
          class="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center"
        >
          <ColorImg src="/images/icons/chat.png" class="w-6 h-6 bg-blue-500" />
        </div>
        <div>
          <h2 class="text-lg font-semibold text-gray-700">Support Rapidoo</h2>
          <p class="text-sm text-gray-500">Une question ? Discutez avec nous</p>
        </div>
      </div>
      <button @click="openAdminChat()" class="buttonComponent small">
        Discuter
      </button>
    </div>

    <!-- KYC Section -->
    <DataFetcher dataKey="kyc" @fetched="onKycFetched">
      <template #any="{ loading, loadingError, refresh }">
        <div class="liquidGlassCard rounded-3xl p-6 w-full mt-6">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-lg font-semibold text-gray-700">KYC</h2>
            <span
              v-if="!loading"
              class="px-3 py-1 rounded-full text-sm font-medium"
              :class="kycStatusClass"
            >
              {{ kycStatusLabel }}
            </span>
          </div>

          <!-- Loading state -->
          <div v-if="loading" class="text-center py-6 text-gray-500">
            <p>Chargement des informations KYC...</p>
          </div>

          <!-- Error state -->
          <div v-else-if="loadingError" class="text-center py-6 text-red-500">
            <p>Erreur lors du chargement</p>
            <button @click="refresh" class="buttonComponent small mt-3">
              Réessayer
            </button>
          </div>

          <!-- Not filled state -->
          <div
            v-else-if="kycStatus === 'not_filled'"
            class="text-center py-6 text-gray-500"
          >
            <p>KYC non rempli</p>
            <router-link to="/kyc" class="buttonComponent mt-5">
              Remplir mon KYC
            </router-link>
          </div>

          <!-- Filled/Pending state -->
          <div
            v-else-if="kycStatus === 'filled'"
            class="text-center py-6 text-gray-500"
          >
            <p>Votre KYC est en attente de validation</p>
            <p class="text-sm mt-2">
              Nous vous informerons dès qu'il sera validé
            </p>
          </div>
          <!-- Validated state -->
          <div
            v-else-if="kycStatus === 'validated' && kycData"
            class="text-center py-6 text-gray-500"
          >
            <p>Kyc Validé</p>
            <p class="text-sm">
              Vous pouvez accéder aux fonctionalités de l'application
            </p>
          </div>

          <!-- Rejected state -->
          <div
            v-else-if="kycStatus === 'rejected'"
            class="text-center py-6 text-gray-500"
          >
            <p>Votre KYC a été rejeté</p>
            <p
              v-if="kycStatusData?.rejectionReason"
              class="text-sm mt-2 text-red-600"
            >
              Raison: {{ kycStatusData.rejectionReason }}
            </p>
            <router-link to="/kyc" class="buttonComponent mt-5">
              Remplir à nouveau
            </router-link>
          </div>
        </div>
      </template>
    </DataFetcher>

    <!-- Delete Account Section -->
    <ActionTrigger
      dataKey="user"
      method="patch"
      @success="onAccountDeleted"
      v-slot="{ trigger: updateProfile, loading: deletingAccount }"
    >
      <div class="liquidGlassCard rounded-3xl p-6 w-full mt-6">
        <button
          @click="confirmDeleteAccount(updateProfile)"
          :disabled="deletingAccount"
          class="w-full flex items-center justify-between font-bold text-red-500 hover:text-red-600"
        >
          <span>Supprimer mon compte</span>
          <svg
            class="w-5 h-5 text-red-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
        </button>
      </div>
    </ActionTrigger>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import Events from '@/events/events'
import ColorImg from '@/presentation/components/img/ColorImg.vue'
import ImgComponent from '@/presentation/components/img/ImgComponent.vue'
import { EVENTS } from '@/shared/constants/commons'

import RiderAvailabilityUpdater from '../sections/profile/RiderAvailabilityUpdater.vue'
import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import Storage from '@/shared/utils/storage'
import DataFetcher from '@/features/data/presentation/components/DataFetcher.vue'

import { openAdminChat } from '@/features/chat/chatUtils.js'

const rider = {
  id: 'RDR-4591',
  name: 'Kossi Dossou',
  rating: 4.3,
  phone: '+229 96 54 78 23',
  email: 'kossi.dossou@example.com',
  address: 'Cotonou, Bénin',
  joinedAt: '2024-03-15T10:30:00Z',
}

const fileInput = ref(null)

function triggerFileInput() {
  fileInput.value?.click()
}

async function handleFileUpload(event, updateProfile) {
  const file = event.target.files[0]
  if (!file) return

  const img = new Image()
  img.src = URL.createObjectURL(file)

  img.onload = async () => {
    const canvas = document.createElement('canvas')
    // Taille fixe idéale pour un avatar (ex: 500x500)
    canvas.width = 500
    canvas.height = 500

    // Dessine l'image en l'adaptant à la taille du canvas
    canvas.getContext('2d').drawImage(img, 0, 0, 500, 500)
    URL.revokeObjectURL(img.src) // Libère la mémoire

    const image = canvas.toDataURL('image/jpeg', 0.7)

    try {
      await updateProfile({
        action: 'update',
        profilePicture: image,
      })
    } catch (error) {
      console.error('File upload failed:', error)
    }
  }
}

function onProfileUpdated({ result }) {
  if (result?.data) {
    // Update local storage
    const userData = Storage.get('userData') || {}
    Storage.save('userData', {
      ...userData,
      profilePicture: result.data.profilePicture,
    })

    profilePicKey.value++

    Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      type: 'success',
      title: 'Profil mis à jour',
      body: 'Votre photo de profil a été modifiée',
    })
  }
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

/** @type {any[]} */
const badges = []

// KYC state
const kycStatus = ref('not_filled')
/** @type {any} */
const kycData = ref({
  fullName: '',
  phoneNumber: '',
  idType: '',
  idNumber: '',
  vehicleType: '',
  licenseNumber: '',
})
const kycStatusData = ref({
  rejectionReason: '',
})
const profilePicKey = ref(0)

// Computed properties for UI
const kycStatusLabel = computed(() => {
  switch (kycStatus.value) {
    case 'not_filled':
      return 'Non rempli'
    case 'filled':
      return 'En attente'
    case 'validated':
      return 'Validé'
    case 'rejected':
      return 'Rejeté'
    default:
      return 'Inconnu'
  }
})

const kycStatusClass = computed(() => {
  switch (kycStatus.value) {
    case 'not_filled':
      return 'bg-gray-100 text-gray-600'
    case 'filled':
      return 'bg-yellow-100 text-yellow-600'
    case 'validated':
      return 'bg-green-100 text-green-600'
    case 'rejected':
      return 'bg-red-100 text-red-600'
    default:
      return 'bg-gray-100 text-gray-600'
  }
})

// Handle KYC data fetch
function onKycFetched(payload) {
  const fetchedData = payload?.data
  console.log('KYC data fetched:', fetchedData)
  if (fetchedData && fetchedData.status) {
    kycStatus.value = fetchedData.status
    kycData.value = fetchedData.kycData || {}
    kycStatusData.value = fetchedData.statusData || {}
  } else {
    kycStatus.value = 'error'
  }
}

function formatDate(dateStr) {
  if (!dateStr) return 'N/A'
  /** @type {any} */
  const dateObj = new Date(dateStr)
  return dateObj.toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

async function confirmDeleteAccount(updateProfile) {
  try {
    const result = await window.customPrompt?.({
      title: 'Supprimer mon compte',
      message:
        'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
      successText: 'Supprimer',
      cancelText: 'Annuler',
    })

    if (result?.accepted) {
      await updateProfile({
        action: 'update',
        metadata: { isDeleted: true },
      })
    }
  } catch (error) {
    console.error('Error deleting rider account:', error)
  }
}

function onAccountDeleted() {
  Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
    type: 'success',
    title: 'Compte supprimé',
    body: 'Votre compte a été supprimé avec succès.',
  })
  setTimeout(() => {
    Events.dispatch(EVENTS.LOGOUT_REQUESTED)
  }, 1000)
}
</script>

<script>
export default {
  name: 'RiderProfile',
}
</script>

<style scoped>
/* Petites transitions pour plus de fluidité */
button {
  transition: all 0.25s ease;
}
</style>
